'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../styleInject.js');

var css_248z = ".Chip-module_chipRoot__-MIU-{border-radius:999px;display:inline-block;padding:4px 8px;width:-moz-fit-content;width:fit-content}.Chip-module_chipWrapper__-yz9G{align-items:center;display:flex;gap:8px;justify-content:center}";
var styles = {"chipRoot":"Chip-module_chipRoot__-MIU-","chipWrapper":"Chip-module_chipWrapper__-yz9G"};
styleInject["default"](css_248z, 'e7b9d3ed-6b29-410f-b19a-7efa3a58622d');

exports["default"] = styles;
